import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Index from './pages/Index';
import KitControl from './pages/KitControl';
import Settings from './pages/Settings';
import Ticker from './pages/Ticker';
import { AuthenticationWrapper } from './components/auth/AuthenticationWrapper';
import { Toaster } from 'sonner';
import ScoreboardPage from './pages/ScoreboardPage';
import NotFound from './pages/NotFound';
import FullScreenTicker from './pages/FullScreenTicker';

// Import the XML and JSON pages
import ScoreboardXMLPage from "./pages/ScoreboardXMLPage";
import RawXMLPage from "./pages/RawXMLPage";
import RawJSONPage from "./pages/RawJSONPage";

// Component for protected routes
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  return (
    <AuthenticationWrapper>
      {children}
    </AuthenticationWrapper>
  );
};

function App() {
  return (
    <div className="App">
      <Routes>
        {/* Public routes that don't require authentication */}
        <Route path="/scoreboard/:number" element={<ScoreboardPage />} />
        <Route path="/fullscreen/scoreboard/:number" element={<ScoreboardPage />} />
        <Route path="/sb/:number" element={<ScoreboardPage />} />
        
        <Route path="/fullscreen/ticker/:number" element={<FullScreenTicker />} />
        
        <Route path="/xml/kit/:number" element={<ScoreboardXMLPage />} />
        <Route path="/xml/raw/kit/:number" element={<RawXMLPage />} />
        <Route path="xml/raw/kit/:number" element={<RawXMLPage />} />
        
        <Route path="/json/raw/kit/:number" element={<RawJSONPage />} />
        <Route path="json/raw/kit/:number" element={<RawJSONPage />} />
        
        {/* Protected routes that require authentication */}
        <Route path="/" element={<ProtectedRoute><Index /></ProtectedRoute>} />
        <Route path="/dashboard" element={<ProtectedRoute><Index /></ProtectedRoute>} />
        <Route path="/kit/:id" element={<ProtectedRoute><KitControl /></ProtectedRoute>} />
        <Route path="/kit-control/:id" element={<ProtectedRoute><KitControl /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
        <Route path="/ticker/:number" element={<ProtectedRoute><Ticker /></ProtectedRoute>} />
        
        {/* Catch-all route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
